const Configuration = {
  apiUrl: process.env.API_URL,
  apiVersion: process.env.API_VERSION,
  emrNotesUrl: process.env.EMR_NOTES_URL,
  emrNotesVersion: process.env.EMR_NOTES_VERSION,
  emrNotesCsp: process.env.EMR_NOTES_CSP,
  emrCalendarsUrl: process.env.EMR_CALENDARS_URL,
  emrCalendarsVersion: process.env.EMR_CALENDARS_VERSION,
  emrCalendarsCsp: process.env.EMR_CALENDARS_CSP,
  emrMessagingUrl: process.env.EMR_MESSAGING_URL,
  emrMessagingVersion: process.env.EMR_MESSAGING_VERSION,
  emrMessagingCsp: process.env.EMR_MESSAGING_CSP,
  env: process.env.NODE_ENV,
  hintEnv: process.env.HINT_ENV || "development",
  fullStoryOrgId: process.env.FULLSTORY_ORG_ID,
  googleMapsKey: process.env.GOOGLE_MAPS_JS_KEY,
  googleRecaptchaSiteKey: process.env.GOOGLE_RECAPTCHA_SITE_KEY,
  intercomAppId: process.env.INTERCOM_APP_ID,
  newRelicAccountId: process.env.NEW_RELIC_ACCOUNT_ID,
  newRelicLicenseKey: process.env.NEW_RELIC_LICENSE_KEY,
  newRelicApplicationId: process.env.NEW_RELIC_APPLICATION_ID,
  release: process.env.GIT_REVISION,
  sentryOrganizationId: process.env.SENTRY_ORGANIZATION_ID,
  sentryProjectId: process.env.SENTRY_PROJECT_ID,
  sentryKey: process.env.SENTRY_KEY,
  sentryEnvironment: process.env.SENTRY_ENVIRONMENT,
  sentryReleaseVersion: process.env.GIT_REVISION,
  stripePublishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
  statuspageEmbedCode: process.env.STATUSPAGE_EMBED_CODE,
  rainforestEnv: process.env.RAINFOREST_ENV || "sandbox",
};

module.exports = Configuration;
